import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export function PageHero({ overline, title, subtitle, image, breadcrumbs = [] }) {
  return (
    <section className="relative bg-navy text-white pt-40 pb-24 sm:pt-48 sm:pb-32 overflow-hidden" data-testid="page-hero">
      <div className="absolute inset-0">
        {image && (
          <img src={image} alt="" loading="eager" className="w-full h-full object-cover opacity-30 ken-burns" />
        )}
        <div className="absolute inset-0 bg-gradient-to-b from-navy/85 via-navy/75 to-navy" />
        <div className="absolute inset-0 hero-grid-overlay opacity-25" />
      </div>

      <div className="container-x relative">
        <nav className="flex items-center gap-2 text-xs text-white/60 mb-6" aria-label="Breadcrumb">
          <Link to="/" className="hover:text-white">Home</Link>
          {breadcrumbs.map((b, i) => (
            <span key={i} className="flex items-center gap-2">
              <ChevronRight size={12} />
              {b.to ? (
                <Link to={b.to} className="hover:text-white">{b.label}</Link>
              ) : (
                <span className="text-white">{b.label}</span>
              )}
            </span>
          ))}
        </nav>

        <motion.div
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-4xl"
        >
          {overline && (
            <div className="flex items-center gap-3">
              <span className="w-10 h-px bg-gold" />
              <span className="overline text-gold">{overline}</span>
            </div>
          )}
          <h1 className="font-display font-extrabold text-5xl sm:text-6xl lg:text-7xl leading-[0.98] tracking-tight mt-6">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-6 text-base sm:text-lg text-white/75 leading-relaxed max-w-2xl">
              {subtitle}
            </p>
          )}
        </motion.div>
      </div>
    </section>
  );
}

export default PageHero;
